import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { GlobalAppFlagsState } from './global-flags.store';

import { AlarmStatus } from '../alerts/alarm.state';
import { CheckInState } from '../check-in/check-in.state';
import { CustomerSettingsState } from '../customer/customer.state';
import { DeviceDetailsState } from '../device/device.state';
import { LicenseState } from '../licensing/licensing.state';
import { NetworkStatusState } from '../network-status/network-status.state';
import { UpdateSessionState } from '../update-session/update-session.state';
import { UserActivityState } from '../user-activity/user-activity.state';
import { UserProfileState } from '../user-profile/user-profile.state';
import { VersionUpdateState } from '../version-update/version-update.state';

export const rootReducer = combineReducers({
  networkStatus: NetworkStatusState.reducer,
  userActivity: UserActivityState.reducer,
  userProfile: UserProfileState.reducer,
  deviceDetails: DeviceDetailsState.reducer,
  alarmState: AlarmStatus.reducer,
  licenseState: LicenseState.reducer,
  checkInState: CheckInState.reducer,
  customerState: CustomerSettingsState.reducer,
  updateSessionState: UpdateSessionState.reducer,
  versionUpdateState: VersionUpdateState.reducer,
  globalAppFlagsState: GlobalAppFlagsState.reducer,
});

export type InitialAppType = ReturnType<typeof rootReducer>;

export const rootStore = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;
